var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHowToUseDp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 172 172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,172v-172h172v172z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0d944a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.6,17.2c-20.98937,0 -35.44812,6.85313 -35.7975,7.2025c-1.37062,0.68531 -2.0425,1.74688 -2.0425,3.1175v10.32h-3.44c-5.84531,0 -10.32,4.47469 -10.32,10.32v89.44c0,5.84531 4.47469,10.32 10.32,10.32h68.0475c1.86781,2.08281 4.515,3.44 7.6325,3.44c3.1175,0 5.76469,-1.35719 7.6325,-3.44h68.0475c5.84531,0 10.32,-4.47469 10.32,-10.32v-89.44c0,-5.84531 -4.47469,-10.32 -10.32,-10.32h-3.44v-10.32c0,-1.37062 -0.67187,-2.43219 -2.0425,-3.1175c-0.34937,-0.34937 -14.80812,-7.2025 -35.7975,-7.2025c-17.54937,0 -30.27469,4.8375 -34.4,6.5575c-4.12531,-1.72 -16.85062,-6.5575 -34.4,-6.5575zM51.6,24.08c15.13063,0 26.48531,3.73563 30.96,5.805v99.4375c-5.84531,-2.06937 -16.85062,-5.16 -30.96,-5.16c-14.10937,0 -25.11469,3.09063 -30.96,5.16v-99.4375c4.47469,-2.06937 15.82938,-5.805 30.96,-5.805zM120.4,24.08c15.13063,0 26.48531,3.73563 30.96,5.805v99.4375c-5.84531,-2.06937 -16.85062,-5.16 -30.96,-5.16c-14.10937,0 -25.11469,3.09063 -30.96,5.16v-99.4375c4.47469,-2.06937 15.82938,-5.805 30.96,-5.805zM120.4,41.28c-3.80281,0 -6.88,3.07719 -6.88,6.88c0,3.80281 3.07719,6.88 6.88,6.88c3.80281,0 6.88,-3.07719 6.88,-6.88c0,-3.80281 -3.07719,-6.88 -6.88,-6.88zM109.435,65.36c-1.89469,0.17469 -3.29219,1.86781 -3.1175,3.7625c0.17469,1.89469 1.86781,3.29219 3.7625,3.1175h3.44v34.4h13.76v-37.84c0,-2.06937 -1.37062,-3.44 -3.44,-3.44h-13.76c-0.1075,0 -0.215,0 -0.3225,0c-0.1075,0 -0.215,0 -0.3225,0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToUseDp);
export default __webpack_public_path__ + "static/media/how-to-use-dp.dc7378f8924e439958f7e76ab7489a51.svg";
export { ForwardRef as ReactComponent };